"use strict";

var _regeneratorRuntime = require("/home/travis/build/ulabox/boksa/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.resetVault = exports.callApi = exports.getRequestParams = exports.getPayload = exports.getNext = void 0;

var _effects = require("redux-saga/effects");

var _lang = require("lodash/lang");

var _util = require("lodash/util");

var _object = require("lodash/object");

var _i18next = _interopRequireDefault(require("i18next"));

var _auth = require("@modules/auth");

var _vault = require("./vault");

var _guard = require("./guard");

var _request = _interopRequireDefault(require("./request"));

var _actions = require("./actions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
/**
 * Select the next trigger action by after the request.
 *
 * @param {RSAA.next} next - By calleer next step
 * @param {Bool} response.ok - Request response status
 * @return {Func} next - Next step
 */


var getNext = function getNext(next, _ref) {
  var ok = _ref.ok;
  if (!next) return _util.identity;
  if ((0, _lang.isFunction)(next)) return next;
  var actionSuccess = next[_actions.CALL_API_SUCCESS];
  var actionFail = (0, _util.defaultTo)(next[_actions.CALL_API_FAIL], function () {
    return 1;
  });
  return ok ? actionSuccess : actionFail;
};
/**
 * Ensure the same output from the API.
 *
 * @param {Object} body - Request payload
 *  @param {*} [data] - Data contained inside successfull responses
 * @param {Object} response - API request meta
 *  @param {Bool} response.ok - Was the request successfull?
 * @param {Func} schema - Pod's schema to ensure a format
 * @return {*} - Can be the error body, the body.data or the schemed body.data
 */


exports.getNext = getNext;

var getPayload = function getPayload(body, response, schema) {
  if (!response.ok) return body;
  return schema(body.data, body);
};

exports.getPayload = getPayload;

var getRequestParams = function getRequestParams(rsaa, language) {
  return [_request.default, rsaa, (0, _vault.getCustomerToken)(), language];
};
/**
 * Execute an API call given an RSAA.
 * The greenpath is:
 * 1. Make API request given an RSAA and vault-stored customerToken
 * 2. Catch the HTTP response and the request payload body
 * 3. Trigger all the next actions as next step from the RSAA
 *  in parallel with the payload and RSAA.nextArgs
 *
 * @param {Object} action - To be RSAA parsed action from a Pod
 */


exports.getRequestParams = getRequestParams;

var callApi =
/*#__PURE__*/
_regeneratorRuntime.mark(function callApi(action) {
  var rsaa, language, _ref2, _ref3, response, body, next, payload, callResponseThunk;

  return _regeneratorRuntime.wrap(function callApi$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          rsaa = (0, _guard.actionToRSAA)(action);
          _context.prev = 1;
          language = _i18next.default.language;
          _context.next = 5;
          return _effects.call.apply(void 0, _toConsumableArray(getRequestParams(rsaa, language)));

        case 5:
          _ref2 = _context.sent;
          _ref3 = _slicedToArray(_ref2, 2);
          response = _ref3[0];
          body = _ref3[1];
          next = (0, _lang.castArray)(getNext(rsaa.next, response));
          payload = getPayload(body, response, rsaa.schema);
          callResponseThunk = response.ok ? _actions.callAPISuccess : _actions.callAPIError;
          _context.next = 14;
          return (0, _effects.put)(callResponseThunk(rsaa.call));

        case 14:
          if (!rsaa.next) {
            _context.next = 17;
            break;
          }

          _context.next = 17;
          return (0, _effects.all)(next.map(function (action) {
            return (0, _effects.put)(action.apply(void 0, [payload].concat(_toConsumableArray(rsaa.nextArgs))));
          }));

        case 17:
          _context.next = 24;
          break;

        case 19:
          _context.prev = 19;
          _context.t0 = _context["catch"](1);
          _context.next = 23;
          return (0, _effects.put)((0, _actions.callAPIError)(rsaa.call));

        case 23:
          console.error("".concat(_actions.CALL_API, "_ERROR"), (0, _object.get)(action, 'route'), _context.t0);

        case 24:
        case "end":
          return _context.stop();
      }
    }
  }, callApi, this, [[1, 19]]);
});

exports.callApi = callApi;

var resetVault =
/*#__PURE__*/
_regeneratorRuntime.mark(function resetVault() {
  return _regeneratorRuntime.wrap(function resetVault$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _vault.setCustomerToken)({
            customerToken: false
          });

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, resetVault, this);
});

exports.resetVault = resetVault;

var api =
/*#__PURE__*/
_regeneratorRuntime.mark(function api() {
  return _regeneratorRuntime.wrap(function api$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(_actions.CALL_API, callApi);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeEvery)(_auth.authActions.SET_CUSTOMER_TOKEN, _vault.setCustomerToken);

        case 4:
          _context3.next = 6;
          return (0, _effects.takeEvery)(_auth.authActions.PURGE_ALL, resetVault);

        case 6:
        case "end":
          return _context3.stop();
      }
    }
  }, api, this);
});

var _default = api;
exports.default = _default;